import { sendResetPasswordEmail } from "../../api/resetPassword";

function resetPassword(email: string) {
  return sendResetPasswordEmail(email);
}

export { resetPassword };
